
<div class="change-password-form-container">

  <h2 class="font-weight-bold align-left">{{'sidebar_menu.change_password' | translate}}</h2>

  <hr style="border: 0.5px solid #d1d1d1;">

  @if (errorMessage) {
    <div class="error-container">
      {{ this.errorMessage }}
    </div>
  }

  <app-change-password-form
    (changePassword)="onChangePassword($event)"
    [buttonLoading]="buttonLoading"
  ></app-change-password-form>
</div>